module.exports = __webpack_public_path__ + "img/logo-horizontal.5b1c6912.svg";